import { TaskAreas, TaskLocation, TaskLocations } from 'modules/Tasks/types';

/**
 * Maps a member page (location) to the Tasks-page area filter, so a feature surface's "View all"
 * deep-links into the filtered task list.
 *
 * The two axes are independent — `location` is which page a task renders on, `area` is what
 * category it belongs to — so this mapping has to be stated rather than derived.
 */
const LOCATION_TO_AREA: Partial<Record<TaskLocation, string>> = {
    [TaskLocations.TAXES]: TaskAreas.TAXES,
    [TaskLocations.TAXES_ITR]: TaskAreas.TAXES,
    [TaskLocations.ACCOUNTING]: TaskAreas.ACCOUNTING,
    [TaskLocations.PAYROLL]: TaskAreas.PAYROLL,
};

export default LOCATION_TO_AREA;
